import React from "react";
import {useSortable} from "@dnd-kit/sortable";
import {CSS} from "@dnd-kit/utilities";

export const SortableItem = ({id, children, disableDrag}) => {
    const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({id});

    const style = {
        transform: CSS.Transform.toString(transform),
        transition: isDragging ? "none" : transition, // 拖拽时禁用过渡动画
        opacity: isDragging ? 0.5 : 1, // 拖拽时降低透明度
        cursor: disableDrag ? "default" : "grab", // 禁用拖拽时修改光标
    };

    return (
        <div ref={setNodeRef} style={style} {...attributes} {...(disableDrag ? {} : listeners)}>
            {children}
        </div>
    );
};